import type { StoreStatus } from '@/types'

interface StatusBadgeProps {
  status: StoreStatus
  showIndicator?: boolean
  size?: 'sm' | 'md'
  className?: string
}

const statusConfig: Record<
  StoreStatus,
  { bg: string; text: string; dot: string | null; label: string }
> = {
  open: {
    bg: 'bg-[var(--color-status-open)]/10',
    text: 'text-[var(--color-status-open)]',
    dot: 'bg-[var(--color-status-open)]',
    label: 'Open',
  },
  closing_soon: {
    bg: 'bg-[var(--color-status-closing)]/10',
    text: 'text-[var(--color-status-closing)]',
    dot: 'bg-[var(--color-status-closing)]',
    label: 'Closing soon',
  },
  closed: {
    bg: 'bg-[var(--color-status-closed)]/10',
    text: 'text-[var(--color-status-closed)]',
    dot: null,
    label: 'Closed',
  },
  opens_soon: {
    bg: 'bg-[var(--color-status-opens-soon)]/10',
    text: 'text-[var(--color-status-opens-soon)]',
    dot: 'bg-[var(--color-status-opens-soon)]',
    label: 'Opens soon',
  },
}

export function StatusBadge({
  status,
  showIndicator = true,
  size = 'md',
  className = '',
}: StatusBadgeProps) {
  const config = statusConfig[status]
  
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs/4',
    md: 'px-2.5 py-1 text-sm/5',
  }

  return (
    <span
      role="status"
      aria-live="polite"
      className={`
        inline-flex items-center gap-1.5 rounded-full font-bold tracking-tight
        ${config.bg} ${config.text} ${sizeClasses[size]}
        ${className}
      `}
    >
      {showIndicator && config.dot && (
        <span
          className={`size-1.5 rounded-full ${config.dot} animate-pulse-dot`}
          aria-hidden="true"
        />
      )}
      {config.label}
    </span>
  )
}
